import {types} from 'mobx-state-tree';
import ListingModel from '../ListingModel';
import GuestModel from '../GuestModel';
import {ListingProvider} from '../enums';

export const ReservationPreviewModel = types.model('ReservationPreview', {
  checkInDate: types.maybe(types.string),
  checkOutDate: types.maybe(types.string),
  confirmationCode: types.maybe(types.string),
  nights: types.maybe(types.number),
  rooms: types.maybe(types.number)
});

export type ReservationPreviewModelType = typeof ReservationPreviewModel.Type;

export type ThreadModelViews = {
  lastReservation?: ReservationPreviewModelType;
  lastDates?: (string | undefined)[];
};

const ThreadModel = types
  .model({
    id: types.identifierNumber,
    checkInDate: types.maybe(types.string),
    checkOutDate: types.maybe(types.string),
    listing: types.maybe(ListingModel),
    guest: types.maybe(GuestModel),
    reservations: types.array(ReservationPreviewModel),
    source: types.maybe(ListingProvider)
  })
  .views<ThreadModelViews>(self => {
    // tslint:disable-next-line:no-any
    const computed = (self as any) as ThreadModelViews;

    return {
      get lastReservation() {
        const {reservations} = self;
        return reservations && reservations.length > 0 ? self.reservations[0] : undefined;
      },
      get lastDates() {
        const {lastReservation} = computed;
        return lastReservation ? [lastReservation.checkInDate, lastReservation.checkOutDate] : undefined;
      }
    };
  });

export type ThreadModelType = typeof ThreadModel.Type;

export default ThreadModel;



// WEBPACK FOOTER //
// ./src/models/ThreadModel/ThreadModel.ts